var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.comentarios.length > 0)?_c('div',{staticClass:"comentarios"},[_c('h6',[_vm._v(_vm._s(_vm.$t('blog.titulo_comentarios')))]),_vm._v(" "),_c('div',{staticClass:"container-text"},_vm._l((_vm.comentarios),function(comentario,key){return _c('comentario-el',{key:key,attrs:{"data":comentario}})}),1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-125d3f5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view-parts/ficha-blog/listado-comentarios.vue
// module id = null
// module chunks = 